import GlobalVariables from "../models/globalVariables";

/**
 * Resolves the preferred fallback assistant when no URL or backend default applies.
 * Prefers Addy AI default assistant (by appID or defaultId), then first in list.
 * @param {Array} assistants - List of assistant objects
 * @returns {Object|null} Preferred assistant or null if list empty
 */
export const resolvePreferredFallbackAssistant = (assistants) => {
  if (!assistants || !assistants.length) return null;
  const byAppId = assistants.find(
    (a) => a.appID === GlobalVariables.ADDY_DEFAULT_ASSISTANT_APP_ID
  );
  if (byAppId) return byAppId;
  const byDefaultId = assistants.find(
    (a) => a.defaultId === GlobalVariables.ADDY_DEFAULT_ASSISTANT_DEFAULT_ID
  );
  if (byDefaultId) return byDefaultId;
  return assistants[0];
};
